import { css } from '@emotion/css';
import { DateTitleWithEndTimes } from 'Shared/frontend/PosterTitle';
import { palette, theme } from 'Shared/frontend/SettingsProvider';
import { useUrls } from 'Shared/SiteProvider';
import { Match, Show, Switch } from 'solid-js';

const imgStyle = () => css({
	width: '100%'
});

const detailsStyle = () => css({
	fontSize: 20,
	padding: '1.5em 1em 0.5em 1em'
});

const specialNameStyle = () => css({
	color: palette().feature,
	paddingBottom: '0.5em',
	fontSize: '1.2em',
	textTransform: 'uppercase'
});

const dateStyle = () => css({
	fontSize: '0.7em',
	textTransform: 'uppercase',
	paddingBottom: '2em'
});

const taglineStyle = () => css({
	fontSize: '0.9em'
});

const moreEventTaglineStyle = () => css(theme().text.plain, {
//	fontSize: '0.9em'
});


export function SpecialsOverlayContent(P)
{
	const special = () => P.special;

	const imageUrl = () => {
		if (!P.special.image?.hash) return '';
		return useUrls().createImageUrl(P.special.image.hash,P.special.image,'Special-image','medium');
	};

//FIXME photoPoster==poster && suppliedPoster==poster?=supplied?  ALso suppliedPoster2?	

	return (<>
		<Switch>
			<Match when={special().imageType == 'suppliedPoster2'}>
				<Show when={special().name}>
					<div class={specialNameStyle()}>{special().name ?? <>&nbsp;</>}</div>
				</Show>

				<img class={imgStyle()} src={imageUrl()}/>
			</Match>
			<Match when={special().imageType == 'photoPoster' || special().imageType == 'suppliedPoster' || special().imageType == 'photo' || special().imageType == 'poster' }>
				<img class={imgStyle()} src={imageUrl()}/>
			</Match>
			<Match when={special().imageType == 'autoNonMusicPoster'}>
				<div class={specialNameStyle()}>{special().name}</div>

				<Show when={special().tagline}>
					<div class={taglineStyle()}>
						{special().tagline}
					</div>
				</Show>
			</Match>
		</Switch>

		<div class={detailsStyle()}>
			<Show when={special().name}>
				<div class={specialNameStyle()}>
					{special().name}
				</div>
			</Show>

			<div class={dateStyle()}>
				{P.times.customLabel ?? <DateTitleWithEndTimes {...P.times}/> } 
			</div>

			<Show when={special().tagline}>
				<div class={taglineStyle()}>
					{special().tagline}
				</div>
			</Show>

			<div class={moreEventTaglineStyle()} innerHTML={special().moreInfo} />
		</div>
	</>);
}

